import React from 'react'
import styled from 'styled-components'
import { Map } from '../../components/Map'

const StyledMap = styled(Map)`
  width: 100%;
  height: 20rem;
`

interface ISchoolLocationMapProps {
  moveXBy?: number
  location?: object
  className?: string
  isShowOverlay?: boolean
  schoolName?: string
}

const SchoolLocationMap: React.FC<ISchoolLocationMapProps> = ({
  location,
  moveXBy = 0,
  className,
  schoolName,
  isShowOverlay = true,
}) => {
  if (!location) {
    return null
  }
  const { coords } = location
  if (!coords || coords.length === 0) {
    return null
  }
  const [lng, lat] = coords
  return (
    <StyledMap
      className={className}
      isShowOverlay={isShowOverlay}
      center={{ lat, lng: lng + moveXBy }}
      markers={[{ lat, lng, popupTitle: schoolName }]}
    />
  )
}

export { SchoolLocationMap }
